import React from 'react';
import closeIcon from '../images/close popup.png';
import warningImg from '../../../images/Warning.png';
import Button from '../../Button';
import {IPropsWarningView} from '../Config/PopUp.types';
import CircularProgress from '@material-ui/core/CircularProgress';

const WarningPopUp = ({close,
    title = '',
    isWarningIcon = true,
    subtitle = '',
    isActiveBtn = true,
    className = '',
    btnList = []}: IPropsWarningView) => (
    <div className='popup-warning'>
        <div className={`popup-warning-inner${className}`}>
            {isWarningIcon && <img alt='warning icon' className='warning-icon' src={warningImg}/>}
            {title && <p className='popup-warning-title'>{title}</p>}
            {subtitle && <p className={`popup-warning-subtitle${className}`}>{subtitle}</p>}
            {isActiveBtn ? <div className={`popup-warning-btn-container${className} ${btnList.length === 1 && 'justify-center'}`}>
                {btnList && btnList.map((btn) => <Button key={btn.title} classNameButton={btn.className} onClick={btn.onClick} isDisabledActive={!!btn.isDisabledActive} >{btn.title}</Button>)}
            </div> : <CircularProgress />}
            {close && isActiveBtn && <img className='close' src={closeIcon} alt='close popup' onClick={close}/>}
        </div>
    </div>
);

export default WarningPopUp;
